import React from "react";

const BaseInput = React.forwardRef(({ label, name, value, onChange, onBlur, error, ...rest }, ref) => {
    return (
        <div className="baseInput">
            <div className="baseInput__inputContainer" id={`${name}__inputContainer`}>
                <input
                    id={name}
                    name={name}
                    type="text"
                    className="baseInput__inputField"
                    autoComplete="off"
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    ref={ref}
                    {...rest}
                />
                <label htmlFor={name} id={`${name}__label`} className="baseInput__label">
                    {label}
                </label>
            </div>
            {error && <div id={`${name}__error`} className="baseInput__error">{error.message}</div>}
        </div>
    );
});

BaseInput.displayName = "BaseInput";

export default BaseInput;